document.addEventListener(
    "DOMContentLoaded",
    function () {
        import("./core/details").then((module) => {
            module.init();
        });
        import("./core/accordion").then((module) => {
            module.init();
        });
        import("./core/navigation").then((module) => {
            module.init();
        });
        import("./yoast/faq-block").then((module) => {
            module.init();
        });
    }
);
